import React from "react";
import TalentList from "../components/talent/TalentList";
import ScrollableTabs from "src/components/ScrollableTabs";

const TalentPool: React.FC = () => {
  return (
    <>
      <ScrollableTabs />
      <TalentList />
    </>
  );
};

export default TalentPool;
